const emptyInbox = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
};
const centerImage = {
    '> .MuiBox-root > .MuiBox-root:has(> img)': {
        justifyContent: 'center',
    },
};
export default {
    emptyInbox,
    centerImage,
};
